export const LOGIN = "login/LOGIN";
export const KEYCLOAKLOGIN = "login/KEYCLOAKLOGIN";
export const HOME_LOGIN = "login/HOME_LOGIN";
export const LOGIN_ERROR = "login/LOGINERROR";
export const LOGIN_COMPLETE = "login/LOGIN_COMPLETE";
export const LOG_OUT = "login/LOG_OUT";
export const LOG_OUT_COMPLETE = "login/LOG_OUT_COMPLETE";
export const UNSET_PATH = "login/UNSET_PATH";
export const UNSET_PATH_SAGA = "login/UNSET_PATH_SAGA";
export const REGISTER_DRIVER = "login/REGISTER_DRIVER";
export const REGISTER_DRIVER_COMPLETE = "login/REGISTER_DRIVER_COMPLETE";
export const SHOW_TERM_AND_CONDITION_MODAL =
  "login/SHOW_TERM_AND_CONDITION_MODAL";
export const HIDE_TERM_AND_CONDITION_MODAL =
  "login/HIDE_TERM_AND_CONDITION_MODAL";
export const SHOW_BUY_TERM_AND_CONDITION_MODAL =
  "login/SHOW_BUY_TERM_AND_CONDITION_MODAL";
export const HIDE_BUY_TERM_AND_CONDITION_MODAL =
  "login/HIDE_BUY_TERM_AND_CONDITION_MODAL";
export const FORGET_PASSWORD = "login/FORGET_PASSWORD";
export const SET_FORGET_PASSWORD = "login/SET_FORGET_PASSWORD";

export const FORGET_USERNAME = "login/FORGET_USERNAME";
export const SET_FORGET_USERNAME= "login/SET_FORGET_USERNAME";

export const RESET_PASSWORD = "login/RESET_PASSWORD";
export const SHOW__ALL_BUY_PERMIT_LIST_MODAL =
  "login/SHOW__ALL_BUY_PERMIT_LIST_MODAL";
export const HIDE__ALL_BUY_PERMIT_LIST_MODAL =
  "login/HIDE__ALL_BUY_PERMIT_LIST_MODAL";
export const SHOW_CITATION_DETAILS_MODAL = "login/SHOW_CITATION_DETAILS_MODAL";
export const HIDE_CITATION_DETAILS_MODAL = "login/HIDE_CITATION_DETAILS_MODAL";
export const SHOW_VIEW_ORDERS_DETAILS_MODAL =
  "login/SHOW_VIEW_ORDERS_DETAILS_MODAL";
export const HIDE_VIEW_ORDERS_DETAILS_MODAL =
  "login/HIDE_VIEW_ORDERS_DETAILS_MODAL";
export const VERIFY_EMAIL = "driver/VERIFY_EMAIL";

export const SHOW_PRIVACY_POLICY_MODAL = "login/SHOW_PRIVACY_POLICY_MODAL";
export const HIDE_PRIVACY_POLICY_MODAL = "login/HIDE_PRIVACY_POLICY_MODAL";
export const GET_USER_CONTEXT = "login/GET_USER_CONTEXT";
export const SET_USER_CONTEXT = "login/SET_USER_CONTEXT";

export const GET_CITATION_ENABLED = "login/GET_CITATION_ENABLED";
export const SET_CITATION_ENABLED = "login/SET_CITATION_ENABLED";
export const SET_CITATION_APPEALS_PREFERENCES = "login/SET_CITATION_APPEALS_PREFERENCES";
export const GET_CITATION_APPEALS_PREFERENCES = "login/GET_CITATION_APPEALS_PREFERENCES";

export const SHOW_MISSMATCH_DRIVER_ID_MODAL = "login/SHOW_MISSMATCH_DRIVER_ID_MODAL";     
export const HIDE_MISSMATCH_DRIVER_ID_MODAL = "login/HIDE_MISSMATCH_DRIVER_ID_MODAL";

export const getUserContext = () => {
  return {
    type: GET_USER_CONTEXT,
  };
};

export const setUserContext = (data) => {
  return {
    type: SET_USER_CONTEXT,
    payload: data,
  };
};

export const login = (data) => {
  return {
    type: LOGIN,
    payload: data,
  };
};
export const Keycloaklogin = (data) => {
  return {
    type: KEYCLOAKLOGIN,
    payload: data,
  };
};

export const Homelogin = (data) => {
  return {
    type: HOME_LOGIN,
    payload: data,
  };
};

export const loginComplete = (data) => {
  return {
    type: LOGIN_COMPLETE,
    payload: data,
  };
};

export const logOut = () => {
  return {
    type: LOG_OUT,
  };
};

export const logOutComplete = () => {
  return {
    type: LOG_OUT_COMPLETE,
  };
};

export const unsetPath = () => {
  return {
    type: UNSET_PATH,
  };
};

export const showTermAndCondition = () => {
  return {
    type: SHOW_TERM_AND_CONDITION_MODAL,
  };
};

export const hideTermAndCondition = () => {
  return {
    type: HIDE_TERM_AND_CONDITION_MODAL,
  };
};

export const showBuyTermAndCondition = () => {
  return {
    type: SHOW_BUY_TERM_AND_CONDITION_MODAL,
  };
};
export const hideBuyTermAndCondition = () => {
  return {
    type: HIDE_BUY_TERM_AND_CONDITION_MODAL,
  };
};
export const showAllBuyPermitList = () => {
  return {
    type: SHOW__ALL_BUY_PERMIT_LIST_MODAL,
  };
};
export const hideAllBuyPermitList = () => {
  return {
    type: HIDE__ALL_BUY_PERMIT_LIST_MODAL,
  };
};
export const showCitationDetailsModal = () => {
  return {
    type: SHOW_CITATION_DETAILS_MODAL,
  };
};
export const hideCitationDetailsModal = () => {
  return {
    type: HIDE_CITATION_DETAILS_MODAL,
  };
};
export const showViewOrderDetailsModal = () => {
  return {
    type: SHOW_VIEW_ORDERS_DETAILS_MODAL,
  };
};
export const hideViewOrderDetailsModal = () => {
  return {
    type: HIDE_VIEW_ORDERS_DETAILS_MODAL,
  };
};
export const showPrivacyPolicyModal = () => {
  return {
    type: SHOW_PRIVACY_POLICY_MODAL,
  };
};

export const hidePrivacyPolicyModal = () => {
  return {
    type: HIDE_PRIVACY_POLICY_MODAL,
  };
};
//MisMatch Driver Id
export const showMissMatchDriverIdModal = () => {           
  return {
    type: SHOW_MISSMATCH_DRIVER_ID_MODAL,
  };
};

export const hideMissMatchDriverIdModal = () => {
  return {
    type: HIDE_MISSMATCH_DRIVER_ID_MODAL,
  };
};

export const registerDriver = (data) => {
  return {
    type: REGISTER_DRIVER,
    payload: data,
  };
};
export const registerDriverComplete = (data) => {
  return {
    type: REGISTER_DRIVER_COMPLETE,
    payload: data,
  };
};
export const forgetPassword = (data) => {
  return {
    type: FORGET_PASSWORD,
    payload: data,
  };
};
export const setforgetPassword = (data) => {
  return {
    type: SET_FORGET_PASSWORD,
    payload: data,
  };
};
// forget userName start
export const forgetUserName = (data) => {
  return {
    type: FORGET_USERNAME,
    payload: data,
  };
};
export const setforgetUserName = (data) => {
  return {
    type: SET_FORGET_USERNAME,
    payload: data,
  };
};
// forget userName end
export const resetPassword = (data) => {
  return {
    type: RESET_PASSWORD,
    payload: data,
  };
};

export const verifyEmail = (data) => {
  return {
    type: VERIFY_EMAIL,
    payload: data,
  };
};

export const getCitationEnabled = (data) => {
  return {
    type: GET_CITATION_ENABLED,
    payload: data,
  };
};

export const setCitationEnabled = (data) => {
  return {
    type: SET_CITATION_ENABLED,
    payload: data,
  };
};


// Appeal Duration Days
export const setCutationDurationDay = (data) => {
  return {
    type: SET_CITATION_APPEALS_PREFERENCES,
    payload: data
  }
};

export const getCutationDurationDay = (data) => {
  return {
    type: GET_CITATION_APPEALS_PREFERENCES,
    payload: data
  }
}

export const SET_KEYCLOAK_USER = "login/SET_KEYCLOAK_USER";

export const setKeycloakData = (data) => {
  return {
    type: SET_KEYCLOAK_USER,
    payload: data
  }
};
